import React, { ComponentType } from 'react';
import Slider from '@uds/slider';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { Container } from '@uds/grid';

import AdvertCard, { AdvertCardProps } from './AdvertCard';
import Ribbon from '../Ribbon';

interface OuterProps extends RibbonProps {
  ads: Array<AdvertCardProps>;
}

export const PureAds = ({ id, colorway, loading, name, hBaseline = 1, ads, layout }: OuterProps) => (
  <Ribbon id={id} colorway={colorway} loading={loading} layout={layout} name={name} type={Type.ADS}>
    <Container>
      <Slider visibleItems={[1, 2, 3, 3, 4]}>
        {ads.map((ad, i) => (
          <AdvertCard
            key={`advert_card_${id}_`.concat(String(i))}
            colorway={colorway}
            hBaseline={hBaseline}
            ribbonId={id}
            {...ad}
          />
        ))}
      </Slider>
    </Container>
  </Ribbon>
);

PureAds.displayName = 'Ads';

export default visibilitySet(errorBoundary(PureAds)) as ComponentType<OuterProps>;
